import { render, staticRenderFns } from "./DashboardSellerTotal.vue?vue&type=template&id=59a3c7ff&scoped=true&"
import script from "./DashboardSellerTotal.vue?vue&type=script&lang=js&"
export * from "./DashboardSellerTotal.vue?vue&type=script&lang=js&"
import style0 from "./DashboardSellerTotal.vue?vue&type=style&index=0&id=59a3c7ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a3c7ff",
  null
  
)

export default component.exports